<template>
  <b-row>
    <b-col lg="12">
      <!-- .name -->
      <validation-observer ref="registerForm" #default="{ invalid }">
        <b-form>
          <b-row>
            <!-- .user -->
            <b-col lg="6">
              <b-form-group
                id="input-group-1"
                :label="$t('bonuses.user')"
                label-for="input-1"
              >
                <validation-provider
                  #default="{ errors }"
                  name="user"
                  vid="user"
                  rules="required"
                >
                  <b-form-select
                    v-model="user"
                    :options="users"
                    text-field="name"
                    value-field="id"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t('bonuses.user')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- .name -->
            <b-col lg="6">
              <b-form-group
                id="input-group-2"
                :label="$t('bonuses.name')"
                label-for="input-2"
              >
                <validation-provider
                  #default="{ errors }"
                  name="name"
                  vid="name"
                  rules="required"
                >
                  <b-form-input
                    id="input-2"
                    v-model="newItem.name"
                    type="text"
                    :placeholder="$t('bonuses.name')"
                    :state="errors.length > 0 ? false : null"
                  >
                  </b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- .amount -->
            <b-col lg="6">
              <b-form-group
                id="input-group-3"
                :label="$t('bonuses.amount')"
                label-for="input-3"
              >
                <validation-provider
                  #default="{ errors }"
                  name="amount"
                  vid="amount"
                  rules="required"
                >
                  <b-form-input
                    id="input-3"
                    v-model="newItem.amount"
                    type="text"
                    :placeholder="$t('bonuses.amount')"
                    :state="errors.length > 0 ? false : null"
                  >
                  </b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- .month -->
            <b-col lg="6">
              <b-form-group
                id="input-group-4"
                :label="$t('bonuses.month')"
                label-for="input-4"
              >
                <validation-provider
                  #default="{ errors }"
                  name="month"
                  vid="month"
                  rules="required"
                >
                  <b-form-input
                    id="input-4"
                    v-model="newItem.month"
                    type="text"
                    :placeholder="$t('bonuses.month')"
                    :state="errors.length > 0 ? false : null"
                  >
                  </b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- .description -->
            <b-col lg="6">
              <b-form-group
                id="input-group-5"
                :label="$t('bonuses.description')"
                label-for="input-5"
              >
                <validation-provider
                  #default="{ errors }"
                  name="description"
                  vid="description"
                  rules="required"
                >
                  <ckeditor
                    :config="{ contentsLangDirection: 'rtl', versionCheck : false }"
                    id="textarea-2"
                    v-model="newItem.description"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t('polls.description')"
                    rows="8"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col lg="6">
              <b-button
                block
                :disabled="invalid"
                variant="primary"
                @click="submit()"
              >
                <i class="fa fa-plus" /> {{ $t("site.save") }}
              </b-button>
            </b-col>
            <b-col lg="6">
              <b-button block @click="goToTable()" variant="success">
                <i class="fas fa-ban"></i> {{ $t("site.cancel") }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-col>
  </b-row>
</template>

<script>
import Controller from "@/Controllers/BonusesController";
import config from "@/config/config";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
export default {
  name: "BonusesForm",
  props: ["newItem"],
  components: {
    ValidationProvider,
    ValidationObserver,
    required,
  },
  data() {
    return {
      file: {},
      
      user: [],
    };
  },
  methods: {
    async    goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      let ret = await new Controller().From(this.newItem, "FormData");
      if (ret) {
        this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
        this.$parent.$parent.firstTab();
      }
    },
    goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
  },
};
</script>

